import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import styles from "@styles/cropper/editImage.module.css";
import { LinearProgress, Modal } from "@mui/material";
import { ImageCompress } from "@utils/image/ImageCompression";
function EditModal(props) {
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 100,
    aspect: props.aspectRatio
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  const onLoad = useCallback(img => {
    imgRef.current = img;
  }, []);
  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return () => {};
    }
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
  }, [completedCrop]);
  async function finishCrop() {
    props.setOpen(false);
    setShowProgress(true);
    const finishedImage = await compressImage(previewCanvasRef.current);
    props.setImages(finishedImage);
    setShowProgress(false);
  }
  function ProgressModal() {
    return <Modal open={showProgress} data-sentry-element="Modal" data-sentry-component="ProgressModal" data-sentry-source-file="Cropper.jsx">
        <div className={styles.progress}>
          <div className={styles.progressBarContainer}>
            <LinearProgress data-sentry-element="LinearProgress" data-sentry-source-file="Cropper.jsx" />
            <p>Loading...</p>
          </div>
        </div>
      </Modal>;
  }
  function getImageData(canvas, fileName) {
    return new Promise(resolve => {
      canvas.toBlob(blob => {
        blob.name = fileName;
        resolve(blob);
      }, "image/jpeg", 1);
    });
  }
  const compressImage = async canvas => {
    const file = await getImageData(canvas, props.filename);
    const compressedFile = await ImageCompress(file);
    if (props.filename && compressedFile) return compressedFile;
  };
  return <>
      <Modal open={props.open} data-sentry-element="Modal" data-sentry-source-file="Cropper.jsx">
        <>
          <div className={styles.main}>
            <div className={styles.cropper}>
              <h5>Edit Image</h5>

              <ReactCrop src={props.image} onImageLoaded={onLoad} crop={crop} keepSelection={true} onChange={c => setCrop(c)} onComplete={c => setCompletedCrop(c)} imageStyle={{
              width: "auto",
              maxHeight: "70vh",
              maxWidth: "60vw"
            }} data-sentry-element="ReactCrop" data-sentry-source-file="Cropper.jsx" />

              <div className={styles.buttons}>
                <button className={"btn " + styles.cancel_btn} onClick={() => props.setOpen(false)}>
                  Cancel
                </button>

                <button type="button" className={"btn " + styles.done_btn} disabled={!completedCrop?.width || !completedCrop?.height} onClick={finishCrop}>
                  Done
                </button>
              </div>
            </div>
          </div>
          <div className={styles.canvas}>
            <canvas ref={previewCanvasRef}
          // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
          style={{
            width: Math.round(completedCrop?.width ?? 0),
            height: Math.round(completedCrop?.height ?? 0)
          }} />
          </div>
        </>
      </Modal>
      <ProgressModal data-sentry-element="ProgressModal" data-sentry-source-file="Cropper.jsx" />
    </>;
}
export default EditModal;